import { handleDisabledRightClick } from 'ts-utils'

const FaceLogo = (props) => {
    return (
        <img src={`${process.env.REACT_APP_IMG}/server/face-logo.svg?1`} alt="Listovey" {...props} onContextMenu={handleDisabledRightClick}/>
    )
}

export default FaceLogo